export const PROJECT_SENDING_REQUEST = "PROJECT_SENDING_REQUEST"
export const PROJECT_PENDING_DONE = "PROJECT_PENDING_DONE"
export const PROJECT_LIST_SUCCESS = "PROJECT_LIST_SUCCESS"
export const PROJECT_REQUEST_FAIL = "PROJECT_REQUEST_FAIL"
export const PROJECT_LIST_ADD = "PROJECT_LIST_ADD"
export const PROJECT_SINGLE_SUCCESS = "PROJECT_SINGLE_SUCCESS"
export const PROJECT_SINGLE_UPDATE = "PROJECT_SINGLE_UPDATE"
export const PROJECT_SINGLE_UPDATE_FROM_ALL = "PROJECT_SINGLE_UPDATE_FROM_ALL"
export const TOGGLE_EMAIL_REMINDERS_SUCCESS = "TOGGLE_EMAIL_REMINDERS_SUCCESS"
export const TOGGLE_EMAIL_REMINDERS_FAIL = "TOGGLE_EMAIL_REMINDERS_FAIL"
export const PROJECT_SEARCH_INPUT = "PROJECT_SEARCH_INPUT"

